import Model from './Model';

export default class Activity extends Model {
    resource () {
        return 'activity';
    }
}
